import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectFeatureFlag } from 'lib-bw-svc-apis/src/lib/featureFlags/feature-flags.selectors';
import { HttpService } from '../http/http.service';
import { environment } from 'environments/environment';
import { apiConstant } from '../constant/apiConstant';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagsService {
  constructor(
    private store: Store,
    private httpService: HttpService
  ) {}
  private agendaCustomColors: boolean = false;
  private aiCustomQuery: boolean = false;

  isEnabled_AiCustomQuery(): boolean {
    let aiCustomQuery: boolean = false;
    this.store.select(selectFeatureFlag('aiCustomQuery')).subscribe(event => (aiCustomQuery = event));
    return aiCustomQuery;
  }
}
